import styled from 'styled-components';
import { withEllipsis, withShadow } from './styles';
import { paddingProps } from './props';

export const Card = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  width: ${(p) => {
    /* Default 4 cards per line */
    const maxPerLine = p.cardsPerLine || 4;
    /* formula to fit X cards in one row based on a given gutter */
    /* eslint-disable-next-line no-mixed-operators */
    const reduceWidth = p.gutter * 3 / 4;
    return `calc(${100 / maxPerLine}% - ${reduceWidth}px)`;
  }};
  /* ignore margin if card is on the right edge */
  margin-right: ${p => p.position % (p.cardsPerLine || 4) ? `${p.gutter}px` : 0};
  ${withShadow};
  border-radius: 4px;
  min-width: 280px;
  `;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px;
  min-height: 40px;
  ${p => p.skipBorder ? '' : `border-bottom: 1px solid ${p.theme.colors.border}`};
  ${paddingProps};
  `;

export const CardTitle = styled.div`
  color: ${p => p.theme.colors.theme};
  font-weight: ${p => p.theme.fontWeight.bolder};
  font-size: 15px;
  ${withEllipsis};
  `;

export const CardBody = styled.div`
  padding: 10px 15px 0 15px;
  ${paddingProps};
  `;
